import { useQuery } from '@apollo/client'
import {
  GetMemberTestSessions,
  GetMemberTestSessionsVariables,
  SortDirectionEnum,
} from '../../types'
import { GET_MEMBER_TEST_SESSIONS } from './operations'
import { SortByType } from '../../constants'

const DEFAULT_PAGE_LENGTH = 5

interface Props {
  userId: string
  companyId: string
  page?: number
  pageLength?: number
  skipResult?: boolean
  groupIds?: string[]
}

export const useMemberTestSessions = ({
  userId,
  companyId,
  page = 1,
  pageLength = DEFAULT_PAGE_LENGTH,
  skipResult = false,
  groupIds,
}: Props) =>
  useQuery<GetMemberTestSessions, GetMemberTestSessionsVariables>(GET_MEMBER_TEST_SESSIONS, {
    variables: {
      filterData: {
        user: {
          id: userId,
        },
        company: {
          id: companyId,
        },
        groupIds,
      },
      testsFilterData: {
        userIds: [userId],
        companyIds: [companyId],
        onlyPermitted: true,
        participantOnly: true,
      },
      pagination: {
        from: Number(page) * pageLength - pageLength || 0,
        length: pageLength,
        sortBy: SortByType.DATE,
        direction: SortDirectionEnum.DESC,
      },
      skipResult,
    },
  })
